export default class SoundResourceOptions {}
